import { useEffect } from 'react'
import { brand } from '../config/settings/brand'

const origin = brand.url.replace(/\/$/, '')

export function absolutePageUrl(path) {
  if (!path || path === '/') return `${origin}/`
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${origin}${normalized.replace(/\/+$/, '')}`
}

/**
 * Sets title, canonical and og:url for the current public route.
 * Complements the sync snippet in public/index.html (first paint / crawlers).
 */
export default function useDocumentSeo({ title, path, description } = {}) {
  useEffect(() => {
    const canonical = document.querySelector('link[rel="canonical"]')
    const ogUrl = document.querySelector('meta[property="og:url"]')
    const metaDesc = document.querySelector('meta[name="description"]')

    const prev = {
      title: document.title,
      canonical: canonical?.getAttribute('href'),
      ogUrl: ogUrl?.getAttribute('content'),
      description: metaDesc?.getAttribute('content'),
    }

    if (title) document.title = title

    if (path != null) {
      const url = absolutePageUrl(path)
      if (canonical) canonical.setAttribute('href', url)
      if (ogUrl) ogUrl.setAttribute('content', url)
    }

    if (description && metaDesc) metaDesc.setAttribute('content', description)

    return () => {
      document.title = prev.title
      if (canonical && prev.canonical) {
        canonical.setAttribute('href', prev.canonical)
      }
      if (ogUrl && prev.ogUrl) ogUrl.setAttribute('content', prev.ogUrl)
      if (metaDesc && prev.description) {
        metaDesc.setAttribute('content', prev.description)
      }
    }
  }, [title, path, description])
}
